import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=a5060652&scoped=true&"
import script from "./Square.vue?vue&type=script&lang=js&"
export * from "./Square.vue?vue&type=script&lang=js&"
import style0 from "./Square.vue?vue&type=style&index=0&id=a5060652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5060652",
  null
  
)

export default component.exports